<template>
  <section v-if="sections.length" class="Pqb">
    <header class="Pqb__hdr">
      <h2>Votre devis</h2>
      <p class="Pqb__sub">Votre séminaire clé en main</p>
    </header>

    <div v-for="(sec, sIdx) in sections" :key="sIdx" class="Pqb__sec">
      <div v-if="sec.title" class="Pqb__band Pqb__band--black">
        <span>{{ sec.title }}</span>
      </div>

      <div class="Pqb__scroll">
        <table class="Pqb__tbl">
          <thead v-if="(sec.columns || []).length" class="Pqb__thead">
            <tr>
              <th
                v-for="(c, i) in sec.columns"
                :key="i"
                :class="isNumHeader(c) ? 'is-num' : ''"
                v-text="c"
              />
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(row, ri) in sec.rows"
              :key="ri"
              :class="{ 'is-total': isTotalRow(row) }"
            >
              <td
                v-for="(cell, ci) in row"
                :key="ci"
                :class="ci > 0 && isNumeric(cell) ? 'is-num' : ''"
                v-text="cell"
              />
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="hasGrandTotal(sec)" class="Pqb__band Pqb__band--green">
        <span class="left">{{ grandLabel(sec) }}</span>
        <span class="right">{{ grandAmount(sec) }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PublicQuoteBreakdown',
  props: {
    breakdown: { type: [Object, String], default: () => ({}) }
  },
  computed: {
    parsed() {
      if (typeof this.breakdown === 'string') {
        try { return JSON.parse(this.breakdown) || {} } catch { return {} }
      }
      return this.breakdown || {}
    },
    sections() {
      const secs = Array.isArray(this.parsed.sections) ? this.parsed.sections : []
      return secs.map(s => ({
        title: s.title || '',
        columns: (s.columns || []).map(v => String(v ?? '')),
        rows: (s.rows || []).map(r => (r || []).map(c => String(c ?? '')))
      }))
    }
  },
  methods: {
    isNumHeader(txt) {
      const t = (txt || '').toLowerCase()
      return /ht|ttc|quantit|total|tarif/.test(t)
    },
    isNumeric(v) {
      const s = String(v || '').replace(/\s/g, '')
      return /^[+-]?\d{1,3}(\.\d{3})*(,\d+)?$/.test(s) ||  
             /^[+-]?\d+([.,]\d+)?$/.test(s)       
    },
    isTotalRow(row) {
      const s = row.join(' ').toUpperCase()
      return /(TOTAL|SOUS[\s-]?TOTAL|TARIF\/?JOUR|MONTANT)/.test(s)
    },
    hasGrandTotal(sec) {
      const last = (sec.rows || [])[sec.rows.length - 1] || []
      return this.isTotalRow(last)
    },
    grandLabel(sec) {
      const last = (sec.rows || [])[sec.rows.length - 1] || []
      const label = last[0] || ''
      return label
    },
    grandAmount(sec) {
      const last = (sec.rows || [])[sec.rows.length - 1] || []
      for (let i = last.length - 1; i >= 0; i--) {
        if (this.isNumeric(last[i])) return last[i]
      }
      return last[last.length - 1] || ''
    }
  }
}
</script>

<style scoped>
.Pqb { padding: 18px 0 10px; }
.Pqb__hdr { text-align:center; margin-bottom: 10px; }
.Pqb__hdr h2 { margin:0 0 4px;     font-family: 'Merriweather';
    font-weight: 400;
    font-size: 24px;
    margin: 0 0 clamp(10px, 1.8vw, 14px); }
.Pqb__sub { margin:0; font-size:clamp(16px,2.6vw,24px); color:#1d1d1d; }

.Pqb__sec { max-width:1240px; margin:26px auto 34px; }

.Pqb__band {
  display:flex; align-items:center; justify-content:space-between;
  padding:14px 18px; font-weight:800; letter-spacing:.02em; border-radius:6px;
}
.Pqb__band--black { background:#000; color:#fff; border-radius:6px 6px 0 0; }
.Pqb__band--green { background:#335a4e; color:#fff; border-radius:0 0 6px 6px; }
.Pqb__band .left { }
.Pqb__band .right { margin-left:auto; }

.Pqb__scroll { overflow:visible; }
@media (max-width: 900px){
  .Pqb__scroll { overflow-x:auto; -webkit-overflow-scrolling:touch; }
  .Pqb__scroll::-webkit-scrollbar { height:6px }
}

.Pqb__tbl { width:100%; border-collapse:collapse; background:#fff; table-layout:auto; }

.Pqb__thead th {
  background:#000; color:#fff; text-transform:uppercase;
  font-weight:800; font-size:14px; padding:16px; text-align:left;
  border-bottom:1px solid #000;
}
.Pqb__thead th.is-num { text-align:right; }

.Pqb__tbl td {
  padding:16px; font-size:16px; border-bottom:1px solid #e2ebe6;
}
.Pqb__tbl td.is-num { text-align:right; }

.Pqb__tbl tr.is-total td {
  background:#335a4e; color:#fff; font-weight:800;
}
</style>
